export default object => {
    return JSON.parse(JSON.stringify(object));
};
